module.exports = __webpack_public_path__ + "static/media/md-play-circle.3c1d0b1a.svg";